function saveDiscussion(sess, discussion, topicId) {
    const {Discussion, ForumUser} = sess;
    const result = {
        ...discussion,
        creator: ForumUser.create(discussion.creator),
        topic: topicId,
    }
    Discussion.create(result);
} 

function removeDiscussion(sess, id) {
    const {Discussion} = sess;
    Discussion.withId(id).delete();
}

function updateDiscussionsList(sess, {discussionsId, totalPage, page, nextPage, prePage, filters}) {
    const { List } = sess;
    let discussionsListModel = List.getByName('discussions');
    if (!discussionsListModel) {
        List.create({
            name: 'discussions',
            entityIds: discussionsId,
            filters: Object.entries(filters),
            page,
            totalPage,
            nextPage,
            prePage
        })
    } else {
        discussionsListModel.update({
            entityIds: discussionsId,
            filters: Object.entries(filters),
            page,
            totalPage,
            nextPage,
            prePage
        });
    }
}

function increasePostCount(sess, id) {
    const { Discussion } = sess;
    const target = Discussion.withId(id);
    if (target) {
        target.update({postCount: target.postCount + 1});
    }
}

function decreasePostCount(sess, id) {
    const { Discussion } = sess;
    const target = Discussion.withId(id);
    if (target) {
        target.update({postCount: target.postCount - 1});
    }
}

export default {
    saveDiscussion,
    removeDiscussion,
    updateDiscussionsList,
    increasePostCount,
    decreasePostCount
}